export const InvestmentValueType = {
    isForInvestment: "is_for_investment",
    isRented: "is_rented",
    rentalIncome: "rental_income",
    expectedRentalIncome: "expected_rental_income",
    yieldFactor: "yield_factor",
};
